import { Stack, styled, Typography } from '@mui/material'

import type { RefereeType } from '@/components/EntityPanels/Referee'
import ExpandableSubSection from '@/components/ExpandableSubSection'
import SectionDetail from '@/components/SectionDetail'
import SmallPill from '@/components/SmallPill'
import { ItemHeader } from '@/components/Style/Common'

import type { Referee } from './types'

const StyledReferenceDetails = styled('div')`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 5px;
`

const StyledComments = styled('div')`
  position: relative;
  padding: 12px 15px;
  background-color: #f9f9f9;
  border-radius: 5px;
`

export interface Props {
  referee: Referee
  refereeType: RefereeType
  applicantName?: string
  navigateToReferee: (id: string) => void
  referenceDetails?: Record<string, string>
  decisionComments?: string[]
  additionalContext?: string
}

const ReferenceDetails = ({
  referee,
  refereeType,
  applicantName,
  referenceDetails,
  decisionComments,
  additionalContext,
  navigateToReferee,
}: Props) => {
  return (
    <div>
      <ExpandableSubSection heading="Reference Details">
        <Stack spacing={2} direction="column">
          {applicantName && (
            <Typography variant="body1">
              {referee.name} has been added as {refereeType} reference for {applicantName}
            </Typography>
          )}
          <StyledReferenceDetails>
            <SectionDetail header="Name" value={referee.name} />
            <SectionDetail header="Email" value={referee.email} />
            <SectionDetail header="Phone" value={referee.phone} />
            {referee.jobTitle && (
              <SectionDetail header="Job title" value={referee.jobTitle} />
            )}
          </StyledReferenceDetails>
          {decisionComments !== undefined && (
            <StyledComments>
              <Stack spacing={2} direction="column">
                <ItemHeader>Decision Comments:</ItemHeader>
                <ul style={{ paddingLeft: '20px' }}>
                  {decisionComments.map((comment, i) => (
                    <li>{comment}</li>
                  ))}
                </ul>
              </Stack>
            </StyledComments>
          )}
          {additionalContext !== undefined && (
            <StyledComments>
              <Stack spacing={2} direction="column">
                <ItemHeader>Additional Context:</ItemHeader>
                <p>{additionalContext}</p>
              </Stack>
            </StyledComments>
          )}
          {referenceDetails !== undefined && (
            <StyledReferenceDetails>
              {Object.entries(referenceDetails).map(([key, value], i) => (
                <SectionDetail key={`${key}-${i}`} header={key} value={value} />
              ))}
            </StyledReferenceDetails>
          )}
          <div>
            <SmallPill
              aria-label="Navigate to referee"
              onClick={() => navigateToReferee(referee.id)}
            >
              View Full Reference
            </SmallPill>
          </div>
        </Stack>
      </ExpandableSubSection>
    </div>
  )
}

export default ReferenceDetails
